import { reactive, toRefs } from 'vue';

type toastType = 'success' | 'error' | 'warning' | '';

interface IToastState {
  show: boolean;
  type: toastType;
  message: string;
}

const toastState = reactive<IToastState>({
  show: false,
  type: '',
  message: '',
});

export const useToast = () => {
  const toggleToast = (show: boolean, type?: toastType, message?: string) => {
    toastState.show = show;
    toastState.type = type || '';
    toastState.message = message || '';
  };

  return {
    ...toRefs(toastState),
    toggleToast,
  };
};
